<template>
	<span>
		<sf-data-table
			ref="resultList"
			selection
			paging
			excel
			:columns="columns"
			:rows="resultList"
			:pageUnit="groups.pageUnit"
			:pageArray="screen.pageArray"
			:totalSize="groups.totalSize"
			:currentPage="groups.currentPage"
			@changedPage="changedPage"
		/>
	</span>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/ErrorLog/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	components: {},
	computed: {
		...serviceComputed,
		...rootComputed,
		columns() {
			return [
				{
					label: this.getMessage_('SWCC000204'),
					prop: 'logDt',
					width: '250px'
				},
				{
					label: this.getMessage_('SWCC000205'),
					prop: 'logType',
					width: '150px'
				},
				{
					label: this.getMessage_('SWCC000206'),
					prop: 'pgmId',
					width: '200px'
				},
				{
					label: this.getMessage_('SWCC000207'),
					prop: 'procId',
					width: '200px'
				},
				{
					label: this.getMessage_('SWCC000208'),
					prop: 'msgKey',
					width: '150px'
				},
				{
					label: this.getMessage_('SWCC000209'),
					prop: 'chkFlg',
					width: '180px'
				},
				{
					label: this.getMessage_('SWCC000210'),
					prop: 'errMsg'
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		reloadData(currentPage = 1, pageUnit = this.groups.pageUnit) {
			// this.$emit('Refresh', currentPageVal, pageUnitVal);
			let searchParams = {
				plantCd: this.plant,
				startDt: this.startDt,
				endDt: this.endDt,
				logType: this.logType,
				procId: this.procId,
				message: this.message,
				chkFlag: this.chkFlag ? '1' : ''
			};

			this.getErrorLogList_({ searchParams, currentPage, pageUnit })
				.then(header => {})
				.catch(e => {
					this.$sf_toast({
						title: 'error',
						type: 'error',
						position: 'bottom-right',
						message: this.getMessage_(e.header.messageCd)
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		saveClick() {
			const selectedRows = this.$refs.resultList.getSelectedRows();
			if (selectedRows.length < 1) {
				// title 선택한 정보가 없습니다.\
				// message 저장 할 데이터를 선택해 주세요.
				this.$sf_showMessage({ title: this.getMessage_('SWCC000417'), message: this.getMessage_('SWCC000434') });
				return;
			}
			this.$sf_showMessage({
				type: 'confirm',
				message: this.getMessage_('SWCC000555'), // 저장하시겠습니까?
				buttons: [{ title: 'Ok', clickFn: this.save }]
			});
		},
		save() {
			let sendData = {
				status: 1,
				plantCd: this.plant,
				data: []
			};
			const payload = this.$refs.resultList.getSelectedRows();

			this.$sf_toggleLoading(true);
			this.setConfirm_({ plantCd: this.plant, payload })
				.then(data => {
					this.$sf_toast({
						...this.$sf_setToastOption(data.header),
						message: this.getMessage_(data.header.messageCd) !== '' ? this.getMessage_(data.header.messageCd) : data.header.message
					});
					//this.reloadData();
				})
				.then(() => {
					this.reloadData();
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message ? error.message : error
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}
			this.$emit('Refresh', currentPageVal, pageUnitVal);
		}
	}
};
</script>
